.addRow {
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 0.625rem;
	width: 100%;
}


.addRowTextfield {
	flex: 1;

	& :global(.MuiOutlinedInput-root) {
		border-radius: 8px;

		& :global(.MuiOutlinedInput-notchedOutline) {
			border: 1px solid #d9d9d9;
			border-radius: 8px;
		}
	}

	& :global(.MuiOutlinedInput-input) {
		padding: 10px 12px;
	}
}

.addRowButton:global(.MuiButton-root) {
	height: fit-content;
	width: fit-content;
	flex-shrink: 0;
}

.fieldLabel:global(.MuiTypography-root) {
	font-size: 14px;
}


.row {
	display: flex;
	flex-direction: row;
	align-items: center;
	width: 100%;
	border-radius: 10px;

	.button {
		display: flex;
		flex-direction: row;
		gap: 0.875rem;
		align-items: center;
		justify-content: space-between;
		width: 100%;
		padding: 0.625rem 0.9375rem;
	}
}